<template>
    <el-dialog :visible.sync="visible" width="400px" title="新增工程量清单" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="btnList">
            <el-button type="primary" @click="getMiddleImportTemplate()">下载总包清单模版</el-button>
            <el-upload
                    class="upload-demo"
                    :action="actionUrl"
                    :headers="importHeaders"
                    :limit = '1'
                    :on-success="handleSuccess"
                    :file-list="fileList"
                    list-type="picture">
                <el-button type="primary">导入总包清单</el-button>
            </el-upload>
            <el-button type="primary" @click="getMiddleExpectImportTemplate()">下载预计成本模版</el-button>
            <el-upload
                    class="upload-demo"
                    :action="actionUrl1"
                    :headers="importHeaders"
                    :limit = '1'
                    :on-success="handleExpectSuccess"
                    :file-list="fileList"
                    list-type="picture">
                <el-button type="primary">导入预计成本</el-button>
            </el-upload>
            <el-button type="primary" @click="getMiddleActImportTemplate()">下载实际成本模版</el-button>
            <el-upload
                    class="upload-demo"
                    :action="actionUrl2"
                    :headers="importHeaders"
                    :limit = '1'
                    :on-success="handleActSuccess"
                    :file-list="fileList"
                    list-type="picture">
                <el-button type="primary">导入实际成本</el-button>
            </el-upload>
        </div>
    </el-dialog>
</template>

<script>
    import {
        getMiddleImportTemplateService,
        getMiddleExpectImportTemplateService,
        getMiddleActImportTemplateService,
        doImportMiddleDataService,
        doImportMiddleExpectDataService,
        doImportMiddleActDataService,
    } from "../../../services/engineering";
    import {exportExcelService2} from "../../../services/allContractServices";
    import config from "@/common/config";

    export default {
        name: "data-upload-dialog",
        data(){
            return {
                visible: false,
                projectId: '',
                actionUrl: '',
                actionUrl1: '',
                actionUrl2: '',
                importHeaders:{
                    Authorization: sessionStorage.getItem('accessToken')
                },//上传请求头
                fileList:[],

            }
        },

        methods: {
            init(){
                this.visible = true;
                this.actionUrl = config.baseUrl+'/contract-web/project/middle/import/middleData';
                this.actionUrl1 = config.baseUrl+'/contract-web/project/middle/import/middleExpectData';
                this.actionUrl2 = config.baseUrl+'/contract-web/project/middle/import/middleActData';
            },
            getMiddleImportTemplate(){
                let params = {
                    projectId: this.projectId
                }
                getMiddleImportTemplateService(params).then(res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('下载成功');
                        });
                    }
                })
            },
            handleSuccess(res, file, fileList){
                if(res.code == 10000000){
                    this.doImportMiddleData(res.data);
                }else {
                    this.fileList = [];
                    this.$message.error(res.msg);
                }
            },
            doImportMiddleData(middleItems){
                let params = {
                    middleItems: middleItems,
                    projectId: this.projectId
                }
                doImportMiddleDataService(params).then(res => {
                    this.fileList = [];
                    if (res.code == 10000000) {
                        this.$message.success('上传成功');
                        this.$emit('refreshDataList');
                        this.visible = false;
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },

            handleExpectSuccess(res, file, fileList){
                if(res.code == 10000000){
                    this.doImportMiddleExpectData(res.data);
                }else {
                    this.fileList = [];
                    this.$message.error(res.msg);
                }
            },
            doImportMiddleExpectData(middleItems){
                let params = {
                    middleExpectItemList: middleItems,
                    projectId: this.projectId
                }
                doImportMiddleExpectDataService(params).then(res => {
                    this.fileList = [];
                    if (res.code == 10000000) {
                        this.$message.success('上传成功');
                        this.$emit('refreshDataList');
                        this.visible = false;
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },


            handleActSuccess(res, file, fileList){
                if(res.code == 10000000){
                    this. doImportMiddleActData(res.data);
                }else {
                    this.fileList = [];
                    this.$message.error(res.msg);
                }
            },
            doImportMiddleActData(middleItems){
                let params = {
                    middleActItemList: middleItems,
                    projectId: this.projectId
                }
                doImportMiddleActDataService(params).then(res => {
                    this.fileList = [];
                    if (res.code == 10000000) {
                        this.$message.success('上传成功');
                        this.$emit('refreshDataList');
                        this.visible = false;
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },


            getMiddleExpectImportTemplate(){
                let params = {
                    projectId: this.projectId
                }
                getMiddleExpectImportTemplateService(params).then(res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('下载成功');
                        });
                    }
                })
            },
            getMiddleActImportTemplate(){
                let params = {
                    projectId: this.projectId
                }
                getMiddleActImportTemplateService(params).then(res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('下载成功');
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    /deep/.btnList {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        .el-button {
            margin-left: 0px;
            margin-bottom: 10px;
        }
        .el-upload-list{
            display: none;
        }
    }
</style>
